import React from 'react';

import axios from "../../authAxios"
import { 
    MDBCard, 
    MDBCardBody, 
    MDBRow,
    MDBCol,
    MDBCardHeader ,
    MDBIcon
} from 'mdbreact';
import ViewNewsAndUpdate from "./ViewNewsAndUpdate/ViewNewsAndUpdate"

export class News extends React.Component {
    constructor(){
        super();
    this.state = {
        hidden : true,
        addNews : false ,
        date : new Date() ,
        newsArray : [] ,
        viewNews : false ,
        viewNewsObj : {}
    }

    this.handleNewsandUpdate = this.handleNewsandUpdate.bind(this)

}


capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
}


    componentDidMount(){
        axios.post("/visa-admin/getNewsAndUpdates",{
            "user_id": localStorage.getItem("user_id")
        }).then((res)=>{
            // console.log(res);
            if(res.data.data === "success"){
                this.setState({newsArray : res.data.dataobj})
            }
        }).catch((err)=>{
            console.log(err);  
        })
    }


    toggleShow = () => {
        this.setState({ hidden: !this.state.hidden });
    }

  

    handleNewsandUpdate(news){
        // console.log("news",news);
        this.setState({viewNews : true , viewNewsObj : news})
    }

    render(){
     

        if(this.state.viewNews){
            return  <ViewNewsAndUpdate viewNewsObj={this.state.viewNewsObj} />
          }

          return(
            <>
                <h4><b>News and Updates</b></h4>
                    <div className="mt-4">
            <MDBRow >
                <MDBCol size="12" md="12" sm="12">
                 
                    <MDBCard  >
                       <MDBCardHeader> <h5>Recent Updates</h5>  
                        </MDBCardHeader>
                        <MDBCardBody>
                        {this.state.newsArray.map((news)=>(
                        
                            <MDBCard className="mb-3 shadow-none news-and-events" onClick={()=>this.handleNewsandUpdate(news)} >
                              
                                <MDBCardBody> 
                                     <MDBRow >
                                        <MDBCol lg="12">
                                            <h6 className="font-weight-bold">{news.news_title}</h6>
                                            <p className="description">{news.news_message}</p> 
                                            <p > To :  {news.user_types.map((type)=>(
                                            <span className="badge badge-light badge-pill shadow-none mr-2 font-weight-normal p-2" >
                                                {this.capitalize(type.replace(/_/g," "))}
                                            </span>
                                            ))}</p>
                                            <p className="mb-0 text-muted"> <MDBIcon icon="user-alt" className="mr-2" /> {news.sent_by_user_name} <span className="mr-2 ml-2" >|</span>  {new Date(news.sent_on).toDateString()} <span className="" >,</span>  {new Date(news.sent_on).toTimeString()}</p>
                                        </MDBCol>
                                    </MDBRow>
                                     <MDBRow> 
                                    </MDBRow>  
                                </MDBCardBody>
                            </MDBCard>
                                ))}
                            
                          
                        </MDBCardBody>
                       {/* <hr/> */}
                    </MDBCard>
                </MDBCol>
            </MDBRow>
            </div>   
            </>
        )
    }
}

export default News;
